import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './Auth.css';
import API_BASE from '../../config';
import logo from '../../assets/logo.png';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (!/[A-Z]/.test(password)) {
      setError('Password must contain at least one uppercase letter');
      return;
    }
    if (!/[0-9]/.test(password)) {
      setError('Password must contain at least one number');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.detail || 'Failed to reset password');
        return;
      }

      setSuccess(true);
    } catch (err) {
      setError('Unable to connect to the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <div className="auth-logo-div">
              <img src={logo} alt="Kigitz Logo"  />
            </div>
            <p>Invalid Reset Link</p>
          </div>
          <div className="error-message">This password reset link is invalid or has expired.</div>
          <div className="auth-link-center" style={{ marginTop: '16px' }}>
            <Link to="/forgot-password" className="auth-link">
              Request a new reset link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <div className="auth-logo-div">
            <img src={logo} alt="Kigitz Logo"  />
          </div>
          <p>Set a new password</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        {success ? (
          <div>
            <div className="info-message">
              Your password has been reset successfully.
            </div>
            <Link to="/login" className="btn-login" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="At least 8 characters"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your password"
                required
                disabled={loading}
              />
            </div>

            <p className="password-hint">
              Must be 8+ characters with at least one uppercase letter and one number.
            </p>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
